import { render, staticRenderFns } from "./sidebar-nav.vue?vue&type=template&id=57bb9bfd"
import script from "./sidebar-nav.vue?vue&type=script&lang=js"
export * from "./sidebar-nav.vue?vue&type=script&lang=js"
import style0 from "./sidebar-nav.vue?vue&type=style&index=0&id=57bb9bfd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports